export default __webpack_public_path__ + "static/media/arrow.8ce3af32.svg";